import paymentsRoutes from './payments'
import commonRoutes from './commonRoutes'

export default [
  ...paymentsRoutes,
  ...commonRoutes
]
